





































































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, { ALERT_TYPE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import CustomerPricesService from '@/service/CustomerPricesService'
import { CustomerInfo } from '@/domain/CustomerInfo'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    CustomerSelectDialogComponent,
  },
})
export default class MasterCustomerPriceCopy extends Mixins(GlobalMixin) {
  customerPricesService = CustomerPricesService.instance

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "顧客コード", value: "code", width: "140px" },
          { text: "顧客名", value: "customerShortName", width: "300px" },
          { text: "部署名", value: "customerDepartment", width: "200px" },
          { text: "住所", value: "customerAddress" },
          { text: "電話番号", value: "customerTel", width: "120px" },
  ]

  /** 複写元顧客 */
  srcCustomerInfo: CustomerInfo = new CustomerInfo()
  /** 複写先顧客リスト */
  dstCustomers: CustomerInfo[] = []
  /** 顧客選択ダイアログ元(0:複写元選択 1:複写先選択) */
  openDialogSrc = 0

  /**
   * 複写ボタンのクリック
   */
  onSubmit() {
    this.showLoading()
    this.customerPricesService.copy(this.srcCustomerInfo, this.dstCustomers)
        .then(() => {
          this.alert("複写しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("複写に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
        })
  }

  
  /**
   * 複写元顧客選択ダイアログの表示
   */
  openSrcCustomerSelectDialog() {
    this.openDialogSrc = 0
    this.openCustomerSelectDialog()
  }

  /**
   * 複写先顧客選択ダイアログの表示
   */
  openDstCustomerSelectDialog() {
    this.openDialogSrc = 1
    this.openCustomerSelectDialog()
  }

  /**
   * 顧客選択ダイアログの表示
   */
  openCustomerSelectDialog() {
    this.customerSelectDialog = true
  }

  /**
   * 顧客選択
   */
  onCustomerSelected(event: CustomerInfo) {
    if (this.openDialogSrc === 0) {
      this.srcCustomerInfo = event
    } else {
      this.dstCustomers.push(event)
    }
  }

}
